import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Router } from '@angular/router';

import { DepositTypeProperties } from '../models/DepositTypeProperties';

import { DepositService } from '../Services/deposit.service';
import { NgForm } from '@angular/forms';
import { Component } from '@angular/core';
declare var $;

@Component({
    selector: 'app-deposit-type',
    templateUrl: './deposit-type.component.html',
    styleUrls: ['./deposit-type.component.css']
})
/** DepositType component*/
export class DepositTypeComponent {
  /** DepositType ctor */
  all$: DepositTypeProperties[];
  obj = new DepositTypeProperties();
  constructor(private service: DepositService, private router: Router) {
    this.onClickEditDepositType = this.onClickEditDepositType.bind(this);
   // this.onClickEditSupplierAir = this.onClickEditSupplierAir.bind(this);
    //this.onClickEditSupplierVisa = this.onClickEditSupplierVisa.bind(this);
  }


  ngOnInit() {

    try {
      this.loadAllDepositTypes();

    } catch (ex) {  }
  }
  loadAllDepositTypes() {
    this.service.getAllDepositTypes().subscribe((data) => {
      this.all$ = (data);
      //console.log(this.all$);
      

    })
  }
  onClickEditDepositType(e) {
  //  //console.log(e);
    //console.log(e.row.data.depositTypeId);
    this.service.getDepositTypeById(e.row.data.depositTypeId).subscribe((data) => {
      this.obj = data;
    })

  }
  Save() {
   // this.obj.creationUser = 1;
    if (this.obj.creationUser == 0 || this.obj.creationUser == null) {
      this.obj.creationUser = Number(localStorage.getItem("UserId"));
      this.service.create(this.obj).subscribe((data) => {
        if (data == true) {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Saved..!!"
          $("#lblerrormsg").delay(5000).hide(1000);
          this.loadAllDepositTypes();
        }
        else {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Something went wrong..!!"
          $("#lblerrormsg").delay(5000).hide(1000);
          this.loadAllDepositTypes();
        }

      })
    }
    else {
      this.obj.modifyUser = Number(localStorage.getItem("UserId"));
      this.service.update(this.obj).subscribe((data) => {
        if (data == true) {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Saved..!!"
          $("#lblerrormsg").delay(5000).hide(1000);
          this.loadAllDepositTypes();
        }
        else {
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Something went wrong..!!"
          $("#lblerrormsg").delay(5000).hide(1000);
          this.loadAllDepositTypes();
        }
      })
    }
  }
  Cancel() {
    this.obj = new DepositTypeProperties();
  }
}
